
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component({})
export default class DocumentData extends Vue {
  @Prop(Object) contractData!: Object;
  @Prop(Boolean) showDocumentAdditional!: boolean;
}
